import type { TopPvProductsParams } from '~/api/data-source/top-pv';
import { topPvRepository } from '~/api/repository/top-pv';

export const TOP_PV_QUERY_KEY = {
  all: ['top-pv'] as const,

  // 카테고리별 top pv 상품 목록
  products: (params: TopPvProductsParams) => ({
    queryKey: ['/api/market-place/v1/top-pv/products', params] as const,
    queryFn: () => topPvRepository.getTopPvProducts(params),
  }),

  // top pv 카테고리 목록
  categories: (hour: number) => ({
    queryKey: ['/api/market-place/v1/top-pv/categories', hour] as const,
    queryFn: () => topPvRepository.getTopPvCategories(hour),
  }),
};
